import { render, staticRenderFns } from "./advantage.vue?vue&type=template&id=3380104e&scoped=true"
import script from "./advantage.vue?vue&type=script&lang=js"
export * from "./advantage.vue?vue&type=script&lang=js"
import style0 from "./advantage.vue?vue&type=style&index=0&id=3380104e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3380104e",
  null
  
)

export default component.exports